{
  "name": "annual-declarations",
  "version": "2.0.0",
  "engines": {
    "node": ">=22.0.0"
  },
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "build:themes": "npm run build:theme:light && npm run build:theme:dark && npm run build:themes:assets && npm run generate:manifest",
    "build:theme:light": "sass src/themes/variants/cigp-light.scss dist/themes/v1/cigp-light.css --style expanded --embed-source-map && postcss dist/themes/v1/cigp-light.css --use autoprefixer cssnano -o dist/themes/v1/cigp-light.min.css --map",
    "build:theme:dark": "sass src/themes/variants/cigp-dark.scss dist/themes/v1/cigp-dark.css --style expanded --embed-source-map && postcss dist/themes/v1/cigp-dark.css --use autoprefixer cssnano -o dist/themes/v1/cigp-dark.min.css --map",
    "watch:themes": "sass src/themes/variants/cigp-light.scss dist/themes/v1/cigp-light.css --watch",
    "build:themes:assets": "sass src/themes/syncFusion/bootstrap5.3-cigp-light/bootstrap5.3.scss src/assets/sf-bs-cigp-styles/bootstrap5.3.css --style expanded --embed-source-map && postcss src/assets/sf-bs-cigp-styles/bootstrap5.3.css --use autoprefixer cssnano -o src/assets/sf-bs-cigp-styles/bootstrap5.3.min.css --map && sass src/themes/syncFusion/bootstrap5.3-cigp-dark/bootstrap5.3-dark.scss src/assets/sf-bs-cigp-styles/bootstrap5.3-dark.css --style expanded --embed-source-map && postcss src/assets/sf-bs-cigp-styles/bootstrap5.3-dark.css --use autoprefixer cssnano -o src/assets/sf-bs-cigp-styles/bootstrap5.3-dark.min.css --map",
    "watch:themes:assets": "sass --watch src/themes/syncFusion/bootstrap5.3-cigp-light/bootstrap5.3.scss:src/assets/sf-bs-cigp-styles/bootstrap5.3.css src/themes/syncFusion/bootstrap5.3-cigp-dark/bootstrap5.3-dark.scss:src/assets/sf-bs-cigp-styles/bootstrap5.3-dark.css --style expanded --no-source-map",
    "generate:manifest": "node scripts/generate-manifest.js"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.1.7",
    "@angular/cdk": "^22.1.7",
    "@angular/common": "^22.1.7",
    "@angular/compiler": "^22.1.7",
    "@angular/core": "^22.1.7",
    "@angular/forms": "^22.1.7",
    "@angular/material": "^22.1.7",
    "@angular/material-moment-adapter": "^22.1.7",
    "@angular/platform-browser": "^22.1.7",
    "@angular/platform-browser-dynamic": "^22.1.7",
    "@angular/router": "^22.1.7",
    "@azure/msal-angular": "^6.2.1",
    "@azure/msal-browser": "^5.22.0",
    "@rxweb/reactive-form-validators": "^13.0.1",
    "@syncfusion/ej2-angular-buttons": "^34.2.8",
    "@syncfusion/ej2-angular-calendars": "^34.2.8",
    "@syncfusion/ej2-angular-dropdowns": "^34.2.8",
    "@syncfusion/ej2-angular-grids": "^34.2.8",
    "@syncfusion/ej2-angular-inputs": "^34.2.8",
    "@syncfusion/ej2-angular-navigations": "^34.2.8",
    "@syncfusion/ej2-angular-pdfviewer": "^34.2.8",
    "@syncfusion/ej2-angular-popups": "^34.2.8",
    "lodash-es": "^4.18.1",
    "moment": "^2.31.0",
    "ngx-indexed-db": "^22.0.0",
    "ngx-localstorage": "^6.0.0",
    "ngx-logger": "^5.0.12",
    "rxjs": "^7.8.2",
    "tslib": "^2.8.1",
    "zone.js": "^0.16.3"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^22.1.8",
    "@angular/cli": "^22.1.8",
    "@angular/compiler-cli": "^22.1.7",
    "@types/jasmine": "~6.0.0",
    "@types/lodash-es": "^4.17.12",
    "@types/node": "^22.20.3",
    "autoprefixer": "^10.6.1",
    "codelyzer": "^6.0.2",
    "cssnano": "^9.0.5",
    "istanbul-lib-instrument": "^6.0.3",
    "jasmine-core": "~7.0.2",
    "jasmine-spec-reporter": "~7.0.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.3.0",
    "postcss": "^8.5.28",
    "postcss-cli": "^12.0.0",
    "prettier": "^3.9.7",
    "protractor": "~7.0.0",
    "sass": "^1.104.1",
    "ts-node": "~10.9.2",
    "tslint": "~6.1.3",
    "typescript": "~6.0.3"
  },
  "overrides": {
    "ngx-indexed-db": {
      "@angular/common": "$@angular/common",
      "@angular/core": "$@angular/core"
    }
  }
}
